<div [className]="'main-site'">
    <section [className]="'side-menu'">
        <h1>
            <a routerLink="/">
                <img src="/assets/backgrounds/logo.png">
                <span hidden>Daylight Games Studio</span>
            </a>
        </h1>
        <h2 hidden>Let the games be</h2>
        <span>{{url}}</span>
        <ul class="main-menu">
            <li>
                <a [className]="url == '/games'? 'selected': ''" routerLink="/games" translate>home.side_menu.games</a>
            </li>
            <li>
                <a [className]="url == '/about'? 'selected': ''" routerLink="/about" translate>home.side_menu.about_us</a>
            </li>
            <li>
                <a [className]="url == '/blog'? 'selected': ''" routerLink="/blog" translate>home.side_menu.blog</a>
            </li>
            <li>
                <a [className]="url == '/contact'? 'selected': ''" routerLink="/contact" translate>home.side_menu.contact</a>
            </li>
            <li [className]="'languages'">
                <a><img [className]="'flag_en'" src="/assets/svg/en.svg"></a>
                <a><img [className]="'flag_en'" src="/assets/svg/es.svg"></a>
            </li>
        </ul>
    </section>
    <section [className]="'content'">
        <router-outlet></router-outlet>
    </section>
    <section hidden [className]="'footer'">
        <span>Iconos diseñados por <a href="https://www.flaticon.es/autores/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.es/" title="Flaticon"> www.flaticon.es</a></span>
    </section>
</div>